export default "__VITE_ASSET__DSQGYI4H__"